import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/sharedModule/shared.module';
import { StorybookModule } from '@app/storybook/storybook.module';
import { ReturnFromAddressComponent } from './return-from-address/return-from-address.component';
import { ReturnToAddressComponent } from './return-to-address/return-to-address.component';
import { ReturnComponent } from './return.component';
import { SelectItemsRowComponent } from './return-select-items/return-select-items-row/return-select-items-row.component';
import { SelectItemsComponent } from './return-select-items/return-select-items.component';
import { ReturnPackageComponent } from './return-package/return-package.component';
import { ReturnServicesRatesComponent } from './return-services-rates/return-services-rates.component';
import { ReturnShipmentExtrasComponent } from './return-shipment-extras/return-shipment-extras.component';
import {
  IsAddressCorrectedPipe,
  IsBannerRelevantToCurrentStage,
  ReturnReasonOptionPipe,
  SaveBtnDisabledPipe,
  SelectedServiceOption,
} from './pipes/return-feature.pipes';
import { ReturnBannerListComponent } from './return-banner-list/return-banner-list.component';

const components = [
  ReturnComponent,
  SelectItemsComponent,
  SelectItemsRowComponent,
  ReturnToAddressComponent,
  ReturnFromAddressComponent,
  ReturnPackageComponent,
  ReturnServicesRatesComponent,
  ReturnShipmentExtrasComponent,
  ReturnBannerListComponent,
];

const pipes = [
  SaveBtnDisabledPipe,
  ReturnReasonOptionPipe,
  SelectedServiceOption,
  IsAddressCorrectedPipe,
  IsBannerRelevantToCurrentStage,
];
@NgModule({
  imports: [SharedModule, CommonModule, StorybookModule],
  declarations: [...components, ...pipes],
  providers: [],
  exports: [],
})
export class ReturnModule {}
